import { css } from '@linaria/core';

export const headerItemClass = css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    padding: 8px 12px;
    cursor: default;
    transition: all 0.3s ease;
    border-radius: 4px;
    position: relative;

    &.clickable {
        cursor: pointer;

        &:hover {
            background-color: rgba(102, 126, 234, 0.1);

            .header-item-icon,
            .header-item-label {
                color: #667eea;
            }
        }
    }

    &.active {
        background-color: rgba(102, 126, 234, 0.15);

        .header-item-icon,
        .header-item-label {
            color: #667eea;
            font-weight: 600;
        }

        // Active indicator (bottom border)
        &::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translateX(-50%);
            width: 24px;
            height: 2px;
            background-color: #667eea;
            border-radius: 1px;
        }
    }

    @media (max-width: 768px) {
        padding: 6px 8px;
    }
`;

export const headerItemIconClass = css`
    font-size: 1.2rem;
    color: #495057;

    @media (max-width: 768px) {
        font-size: 1rem;
    }
`;

export const headerItemLabelClass = css`
    font-size: 0.75rem;
    color: #495057;
    font-weight: 500;
    text-align: center;
    line-height: 1;
    white-space: nowrap;

    @media (max-width: 768px) {
        font-size: 0.7rem;
    }
`;